<template>
  <section>
    <div class="or-queue-table-wrapper" :class="{'module-height': view === 'ModuleView'}">
      <b-table  v-if="filteredCalls.length" table-class="or-queue-table" :items="filteredCalls" :fields="fields" :per-page="perPage"
        :current-page="currentPage" striped hover bordered outlined fixed small responsive sort-by="queue"
        :sort-desc="true" @filtered="onFiltered">
        <template #cell(origin)="data">
          <strong>{{ data.item.origin }}</strong>
        </template>
        <template #cell(entry)="data">
          <span :title="data.item.entry">
            {{ data.item.entry.length > 27 ? data.item.entry.slice(0, 27) + '...' : data.item.entry }}
          </span>
        </template>
        <template #cell(wait)="data">
          {{ secondsToTime(data.item.wait) }}
        </template>
        <template #cell(queue)="data">
          {{ getQueueAlias(data.item.queue) }}
        </template>
      </b-table>
      <div v-else>
        <div v-if="!reconnection" class="alert alert-warning text-center">Não há chamadas em fila</div>
        <div v-else class="alert alert-danger text-center">Reconectando ao serviço do Realtime...</div>
      </div>
    </div>
    <div class="table-footer">
			<div class="per-page-selector" v-if="view === 'ModuleView'">
				<span>Registros por página: </span>
				<select class="form-control" v-model="perPage">
					<option value="10">10</option>
					<option value="30">30</option>
					<option value="50">50</option>
					<option value="70">70</option>
					<option value="100">100</option>
				</select>
			</div>
			<b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="view === 'ModuleView' ? perPage : filteredCalls.length"
				align="right" size="md" class="my-0"></b-pagination>
		</div>
  </section>
</template>

<script>
export default {
  name: 'OrQueueTable',
  props: [
    'queueList',
    'queueCalls',
    'socketClient',
    'reconnection',
    'enabledListeners',
    'view'
  ],
  data() {
    return {
      fields: [
        { key: 'origin', label: 'Telefone', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center fw-bold' },
        { key: 'queue', label: 'Fila', sortable: true, 'thClass': 'or-custom-header', tdClass: 'text-center align-content-center' },
        { key: 'position', label: 'Posição', sortable: false, 'thClass': 'or-custom-header small-column', tdClass: 'text-center align-content-center' },
        { key: 'wait', label: 'Em espera', sortable: true, 'thClass': 'or-custom-header small-column', tdClass: 'text-center align-content-center' },
      ],
			perPage: this.view === 'OperatorView' ? 10 : 30,
			currentPage: 1,
			totalRows: 0,
      callTimer: null,
      callStartTimes: new Map(),
      currentTime: Date.now(),
    }
  },
  mounted() {
    this.calcCallTimer();
  },
  beforeDestroy() {
    if (this.callTimer) {
      clearInterval(this.callTimer);
    }
  },
  computed: {
    filteredCalls() {
      let filtered = this.updatedCalls.sort((a, b) => {
        if (a.queue === b.queue && a.position < b.position) return -1
        if (a.queue === b.queue && a.position > b.position) return 1
        return 0
      });

      return filtered
    },
    updatedCalls() {
      const arr = []

      if (this.queueCalls.length && this.queueList.length) {
        this.queueCalls.forEach(el => {
          const isUserInQueue = this.queueList.some(q => q.name?.toLowerCase() === el.queue?.toLowerCase())
        
          if (!isUserInQueue) return;
        
          if (!this.callStartTimes.has(el.uniqueid)) {
            const initialWait = parseInt(el.wait) || 0; // ✅ Garantir que seja 0 se NaN/undefined
            this.callStartTimes.set(el.uniqueid, {
              startTime: Date.now(),
              initialWait: initialWait
            });
          }
        
          const callData = this.callStartTimes.get(el.uniqueid);
          const elapsedSeconds = Math.floor((this.currentTime - callData.startTime) / 1000);
          const totalWait = callData.initialWait + elapsedSeconds;
        
          let entry = '---'
          if (el.entry) {
            const arrEntry = el.entry.split(' ')
            if (arrEntry.length) {
              entry = arrEntry[0]
            }
          }
        
          arr.push({
            ...el,
            position: parseInt(el.position, 10),
            wait: totalWait,
            entry
          })
        })
      }
      return arr;
    },
    updatedCallsMap() {
      const map = new Map();
      this.updatedCalls.forEach(call => map.set(call.uniqueid, call));
      return map;
    }
  },
  methods: {
    getQueueAlias(queueName) {
      const match = this.queueList.find(q => q.name?.toLowerCase() === queueName?.toLowerCase());
      return match?.alias || queueName;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async enableListeners() {
      if (!this.socketClient) return
      this.socketClient.removeAllListeners('enteringQueue');
      this.socketClient.removeAllListeners('leavingQueue');

      this.socketClient.on('enteringQueue', async (data) => {
        await this.handleCall(data, 'entering')
      })

      this.socketClient.on('leavingQueue', async (data) => {
        await this.handleCall(data, 'leaving')
      })
    },
    async handleCall(data, type) {
      const call = this.updatedCallsMap.get(data.uniqueid);
      if (type === 'entering') {
        if (!call) {
          this.queueCalls.push(data)
        }
      }
    
      if (type === 'leaving') {
        if (call) {
          const index = this.queueCalls.findIndex(q => q.uniqueid === data.uniqueid); // ✅ Buscar por uniqueid
          if (index !== -1) {
            this.queueCalls.splice(index, 1)

            this.callStartTimes.delete(data.uniqueid);
          
            this.queueCalls.filter(q => q.queue === data.queue)
              .sort((a, b) => a.position - b.position)
              .forEach((q, idx) => {
                q.position = idx + 1;
              });
          }
        }
      }
    },
    calcCallTimer() {
      if (this.callTimer) {
        clearInterval(this.callTimer);
      }

      this.callTimer = setInterval(() => {
        this.currentTime = Date.now();
      }, 1000);
    },
    secondsToTime(seconds) {
      const validSeconds = Number.isFinite(seconds) && seconds >= 0 ? seconds : 0;

      const hours = Math.floor(validSeconds / 3600);
      const minutes = Math.floor((validSeconds % 3600) / 60);
      const secs = validSeconds % 60;
    
      const pad = (num) => String(num).padStart(2, '0');
    
      return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    },
  },
  watch: {
    "enabledListeners.queueCalls": {
      handler(value) {
        if (value) this.enableListeners()
      },
    },
    updatedCalls(value) {
      this.$emit('callsCount', value.length)
    },
    queueCalls: {
      handler() {
        if (!this.callTimer) {
          this.$nextTick(() => {
            this.calcCallTimer()
          });
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.module-height {
	height: calc(100vh - 230px) !important;
	max-height: unset !important;
}

.or-queue-table-wrapper {
  max-height: 68vh;
  overflow-y: auto;
  margin: 10px;

  ::v-deep(.table-responsive) {
    border-radius: 10px 10px 0 0;
    box-shadow: 1px 1px 3px 1px #0000001f
  }

  ::v-deep(.or-custom-header) {
    font-weight: bold;
    text-align: center;
    background-color: #e8873d;
    color: white;
    align-content: center;
  }

  ::v-deep(.small-column) {
    width: 70px;
    text-align: center;
  }

  .icon-extension-status {
    align-self: center;
    margin-right: 5px;
  }

  .custom-queue-badge {
    background-color: #287228;
    border-radius: 5px;
    padding: 2px 5px 2px 5px;
    margin: 2px;
    color: white;
  }

  .incall {
    font-size: smaller;
    font-weight: bold;
    background-color: #2a95b1;
    color: white;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    padding: 2px 10px 2px 10px;

    .call-info {
      display: flex;
      gap: 10px;
    }

    .call-icons {
      display: flex;
      gap: 5px;
      align-items: center;

      .ringing-icon {
        color: darkblue;
      }
    }
  }

  .available {
    font-size: small;
    font-weight: bold;
    background-color: #aaa;
    border-radius: 10px;
  }

  .paused {
    font-size: small;
    font-weight: bold;
    background-color: #c2b049;
    color: white;
    border-radius: 10px;
  }

  .unpaused {
    font-size: small;
    font-weight: bold;
    background-color: #71a17c;
    color: white;
    border-radius: 10px;
  }

  .cursor-help {
    cursor: help;
  }

  .bg-pause {
    background-color: #c2b049;
  }
}

::v-deep(.page-link) {
  font-weight: bold;
  border: none;
  border-radius: 10px !important;
  padding: 5px 10px;
  transition: 0.3s;
  margin: 2px;
  background-color: transparent;

  &:hover {
    background-color: #1c859a85;
  }
}

::v-deep(.page-link[aria-checked="true"]) {
  background-color: #e8873d;
}

::v-deep(.page-link[aria-checked="false"]) {
  color: #e8873d;
}

::v-deep(.page-link[aria-label="Go to next page"]) {
  color: #e8873d;
}

::v-deep(.page-link[aria-label="Go to previous page"]) {
  color: #e8873d;
}

::v-deep(.page-link[aria-label="Go to first page"]) {
  color: #e8873d;
}

::v-deep(.page-link[aria-label="Go to last page"]) {
  color: #e8873d;
}

.table-footer {
	display: flex;
	justify-content: space-between;
	margin: 10px;

	.per-page-selector {
		display: flex;
		gap: 5px;
		white-space: nowrap;
		border-radius: 10px;
		box-shadow: 1px 1px 3px gray;
		font-weight: bold;
		padding-left: 5px;
		transition: 0.3s;
		background-color: #e8873d;
		color: white;

		span {
			align-content: center;
			font-weight: bold;
		}

		select {
			border-radius: 0 10px 10px 0 !important;
			cursor: pointer;
		}
	}
}
</style>